/**
 * checks if a DOM element is visible (e.g. not hidden or width/height 0)
 * @param element
 */
function isVisible(element) {
  return element.offsetWidth > 0 || element.offsetHeight > 0;
}

/**
 * applies the given CSS to the currently loaded page
 * @param css
 */
function applyCssToPage(css) {
  const styleElement = document.createElement('style');
  styleElement.appendChild(document.createTextNode(css));
  document.head.appendChild(styleElement);
}

/**
 * Loads an external Javascript file by adding it to the website as a `<script>` tag
 * @param url
 * @returns {Promise<void>}
 */
async function loadExternalJavascript(url) {
  const scriptElement = document.createElement('script');
  scriptElement.src = url;
  scriptElement.async = true;

  document.head.appendChild(scriptElement);
}

/**
 * Loads an external CSS file by adding it to the website as a `<link>` tag
 * @param url
 * @returns {Promise<void>}
 */
async function loadExternalCss(url) {
  const styleElement = document.createElement('link');
  styleElement.href = url;
  styleElement.type = 'text/css';
  styleElement.rel = 'stylesheet';

  document.head.appendChild(styleElement);
}

export {isVisible, applyCssToPage, loadExternalJavascript, loadExternalCss};
